import type { CommunicationChannel } from "@/api/communications";
import {
  CHANNEL_BG_CLASS,
  CHANNEL_COLOR_CLASS,
  CHANNEL_LABELS,
  ChannelIcon,
} from "./ChannelIcon";
import { cn } from "@/design-system/lib/utils";

interface Props {
  channel: CommunicationChannel;
  className?: string;
}

/**
 * Pill chip with the channel's colour token + Lucide icon. Used in the
 * inbox row, entry-detail header, and dashboard widget.
 */
export function ChannelChip({ channel, className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-space-1 px-space-2 py-[2px]",
        "rounded-pill border font-display text-[10px] font-bold uppercase tracking-[0.12em]",
        CHANNEL_BG_CLASS[channel],
        CHANNEL_COLOR_CLASS[channel],
        className,
      )}
    >
      <ChannelIcon channel={channel} size={12} className="shrink-0" />
      {CHANNEL_LABELS[channel]}
    </span>
  );
}
